module.exports = __webpack_public_path__ + "img/logo.327c1199.png";